export default __webpack_public_path__ + "static/gear_b.503281f48565c88b30af87b1fcb490df.png";